import {RadioField} from '@/components/commons/radio-field/RadioField'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {InputHelpText} from '@/components/ui/input-help-text/InputHelpText'
import {Label} from '@/components/ui/label/Label'
import {useTranslation} from '@/translations/i18n'
import {ChangeEventHandler} from 'react'
import {FieldError} from 'react-hook-form'
import {StyledExternalCostTypeFieldBox} from './style'

interface ExternalCostTypeFieldProps {
    name: string
    value: 'yearly' | 'monthly'
    label: string
    onChange: ChangeEventHandler<HTMLInputElement>
    error?: FieldError
}

export const ExternalCostTypeField = ({name, value, label, onChange, error}: ExternalCostTypeFieldProps) => {
    const {t} = useTranslation()
    return (
        <Flexbox direction="column" gap={1.5} fullWidth>
            <Label>{label}</Label>
            <Flexbox fullWidth direction="column" gap={1.5}>
                <Grid columns={2} gap={1.5} fullWidth>
                    <StyledExternalCostTypeFieldBox spanColumn={1} isSelected={value == 'yearly'} hasError={!!error}>
                        <RadioField
                            label={t('commons:year')}
                            name={name}
                            checked={value == 'yearly'}
                            onChange={onChange}
                            value="yearly"
                        />
                    </StyledExternalCostTypeFieldBox>
                    <StyledExternalCostTypeFieldBox spanColumn={1} isSelected={value == 'monthly'} hasError={!!error}>
                        <RadioField
                            label={t('commons:month')}
                            name={name}
                            checked={value == 'monthly'}
                            onChange={onChange}
                            value="monthly"
                        />
                    </StyledExternalCostTypeFieldBox>
                </Grid>
                {error?.message && <InputHelpText error={error.message} />}
            </Flexbox>
        </Flexbox>
    )
}
